module.exports = __webpack_public_path__ + "static/img/back.2f96adca.png";